var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 455,
    height: 383,
    viewBox: "0 0 455 383",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 176.723,
    y: 46.6318,
    width: 253.961,
    height: 253.961,
    rx: 56.4358,
    stroke: "black",
    strokeWidth: 42.3268
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.486 272.822L239.934 243.607L269.382 214.391L271.897 211.896C296.955 187.036 285.704 144.371 251.645 135.1L84.7075 89.6596C50.6483 80.3886 19.3251 111.465 28.3259 145.596L72.442 312.889C81.4427 347.02 124.017 358.609 149.075 333.748L151.59 331.254L210.021 272.822",
    stroke: "#04C900",
    strokeWidth: 42.3268,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.723 173.612V244.157C176.723 275.326 201.99 300.593 233.158 300.593H303.703",
    stroke: "black",
    strokeWidth: 42.3268
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.92d15c543fe1ca29539f4b504f6820b8.svg";
export { ForwardRef as ReactComponent };